const pageNameKey = "noMachinesDetectedView";

export const noMachinesDetectedViewEn = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Oh no!",
    machinesListEmptyInfoTitle: "No Machines detected, yet!",
    noMachinesDetectedViewImgAlt: "No Machines detected image",
  },
};

export const noMachinesDetectedViewPtBr = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Ah não!",
    machinesListEmptyInfoTitle: "Ainda nenhuma máquina detectada!",
    noMachinesDetectedViewImgAlt: "Nenhuma máquina detectou a imagem",
  },
};

export const noMachinesDetectedViewDe = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Oh nein!",
    machinesListEmptyInfoTitle: "Noch keine Maschinen erkannt!",
    noMachinesDetectedViewImgAlt: "Bild für keine erkannten Maschinen",
  },
};

export const noMachinesDetectedViewZhHans = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "哦，不！",
    machinesListEmptyInfoTitle: "尚未检测到机器！",
    noMachinesDetectedViewImgAlt: "未检测到机器图片",
  },
};

export const noMachinesDetectedViewIt = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Oh no!",
    machinesListEmptyInfoTitle: "Nessuna macchina rilevata finora!",
    noMachinesDetectedViewImgAlt: "Immagine: nessuna macchina rilevata",
  },
};

export const noMachinesDetectedViewEs = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "¡Oh no!",
    machinesListEmptyInfoTitle: "¡Aún no se han detectado máquinas!",
    noMachinesDetectedViewImgAlt: "No se detectó ninguna imagen de máquinas",
  },
};

export const noMachinesDetectedViewNl = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Oh nee!",
    machinesListEmptyInfoTitle: "Nog geen machines gedetecteerd!",
    noMachinesDetectedViewImgAlt: "Afbeelding geen machines gedetecteerd",
  },
};

export const noMachinesDetectedViewTr = {
  [pageNameKey]: {
    machinesListEmptyInfoHintTitle: "Ah hayır!",
    machinesListEmptyInfoTitle: "Henüz hiçbir Makine algılanmadı!",
    noMachinesDetectedViewImgAlt: "Hiçbir Makine algılanmadı resmi",
  },
};
